module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_7.82785315.jpeg";